<div class="table-scroll-wrapper">
  <table class="navinta-table additional-products-table">
    <thead>
      <tr>
        <th class="col-10" i18n="@@productList.productTable.column1.header">Pos.</th>
        <th class="col-18" i18n="@@productList.productTable.column2.header">Anzahl</th>
        <th class="col-auto" i18n="@@productList.productTable.column3.header">Bezeichnung</th>
        <th class="col-20" i18n="@@productList.productTable.column4.header">Sachnummer</th>
        <th class="additional-products-table__remove-column col-5"></th>
      </tr>
    </thead>
    <tbody>
      @if (configs.length === 0) {
        <tr class="additional-products-table__empty-row">
          <td colspan="5">{{ emptyMessage }}</td>
        </tr>
      }
      @for (config of configs; track config.configId) {
        <tr
          class="additional-products-table__config-row"
          [ngClass]="{ discontinued: config.showWarning, incomplete: config.isIncompleteConfiguration }"
        >
          <td>
            {{ config.positionNumber + (!config.showWarning && !config.isIncompleteConfiguration ? "" : " ") }}
            @if (config.showWarning || config.isIncompleteConfiguration) {
              <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
            }
          </td>
          <td class="additional-products-table__quantity" [class.additional-products-table__edit-control-cell]="editMode">
            @if (editMode) {
              <div odxLayout="flex" class="custom-spinbox additional-products-stepper">
                <button
                  type="button"
                  data-icon-set="core"
                  data-icon-name="minus"
                  class="odx-spinbox__action odx-icon"
                  (click)="updateAdditionalProductQuantity(config.configId, -1)"
                ></button>
                <input
                  class="odx-spinbox__input"
                  type="number"
                  min="0"
                  [value]="getDraftQuantity(config)"
                  (input)="setAdditionalProductQuantity(config.configId, $any($event.target).value)"
                />
                <button
                  type="button"
                  data-icon-set="core"
                  data-icon-name="plus"
                  class="odx-spinbox__action odx-icon"
                  (click)="updateAdditionalProductQuantity(config.configId, 1)"
                ></button>
              </div>
            } @else {
              {{ getDraftQuantity(config) }}
            }
          </td>
          <td>{{ config.name }}</td>
          <td>{{ config.mainProductId }}</td>
          <td class="additional-products-table__action" [class.additional-products-table__edit-control-cell]="editMode">
            @if (editMode) {
              <button
                odxButton
                variant="ghost"
                type="button"
                class="additional-products-icon-button"
                aria-label="Aus Produktliste entfernen"
                i18n-aria-label="@@productList.additionalProducts.remove"
                (click)="removeAdditionalProduct(config.configId)"
              >
                <odx-icon name="close"></odx-icon>
              </button>
            } @else {
              <span class="additional-products-icon-placeholder" aria-hidden="true"></span>
            }
          </td>
        </tr>
        @for (product of config.subproducts; track $index) {
          <tr class="additional-products-table__subproduct-row" [ngClass]="{ discontinued: !product.isAvailable }">
            <td>
              {{ product.positionId + (product.isAvailable ? "" : " ") }}
              @if (!product.isAvailable) {
                <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
              }
            </td>
            <td>{{ getProductQuantity(product, config) }}</td>
            <td class="additional-products-table__subproduct-name">{{ product.name }}</td>
            <td>{{ product.matNr }}</td>
            <td></td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
